(function () {
  'use strict';
  function onReady(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }
  function isProduct() {
    try {
      var cls = (document.body && document.body.className) || '';
      return /(^|\s)template-product(\s|$)/.test(cls) || /\/products\//.test(location.pathname);
    } catch (e) { return false; }
  }
  function el(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }
  var BOX = [
    ['🖨️', 'PrintivaTR™ Mini Termal Yazıcı'],
    ['🧾', '3 Beyaz Termal Rulo'],
    ['🌈', '3 Renkli Termal Rulo'],
    ['✏️', '3 Renkli Kalem'],
    ['🔌', 'USB Şarj Kablosu']
  ];
  var COMPARE_ROWS = [
    ['Mürekkep / kartuş', 'Gerekmez — termal baskı', 'Sürekli kartuş masrafı'],
    ['Bağlantı', 'Bluetooth, saniyeler içinde', 'Kablo + kurulum derdi'],
    ['Taşınabilirlik', 'Cebe sığar, şarjlı', 'Masaya sabit, büyük'],
    ['Kutu hediyesi', '3 rulo + 3 renkli rulo + 3 kalem', 'Yok'],
    ['Kargo & iade', "Türkiye'den hızlı + 14 gün iade", 'Belirsiz']
  ];
  function buildBox() {
    var wrap = el('div'); wrap.id = 'pv-included';
    wrap.appendChild(el('h2', 'pv-inc__title', 'Kutunun İçinde'));
    wrap.appendChild(el('p', 'pv-inc__sub', 'Tek kutuda hemen başla.'));
    var grid = el('div', 'pv-inc__grid');
    BOX.forEach(function (it) {
      var item = el('div', 'pv-inc__item');
      item.appendChild(el('div', 'pv-inc__ic', it[0]));
      item.appendChild(el('div', 'pv-inc__lb', it[1]));
      grid.appendChild(item);
    });
    wrap.appendChild(grid);
    return wrap;
  }
  function buildCompare() {
    var wrap = el('div'); wrap.id = 'pv-compare';
    wrap.appendChild(el('h2', 'pv-compare__title', 'Neden PrintivaTR?'));
    wrap.appendChild(el('p', 'pv-compare__sub', 'Sıradan yazıcılarla farkı net.'));
    var table = el('div', 'pv-compare__table');
    var head = el('div', 'pv-compare__row pv-compare__row--head');
    head.innerHTML = '<div class="pv-c pv-c--label"></div>'
      + '<div class="pv-c pv-c--us">PrintivaTR™</div>'
      + '<div class="pv-c pv-c--them">Sıradan Yazıcı</div>';
    table.appendChild(head);
    COMPARE_ROWS.forEach(function (r) {
      var row = el('div', 'pv-compare__row');
      row.appendChild(el('div', 'pv-c pv-c--label', r[0]));
      var c1 = el('div', 'pv-c pv-c--us');
      c1.innerHTML = '<span class="pv-ic pv-ic--ok">✓</span>';
      c1.appendChild(document.createTextNode(r[1]));
      var c2 = el('div', 'pv-c pv-c--them');
      c2.innerHTML = '<span class="pv-ic pv-ic--no">✕</span>';
      c2.appendChild(document.createTextNode(r[2]));
      row.appendChild(c1); row.appendChild(c2);
      table.appendChild(row);
    });
    wrap.appendChild(table);
    return wrap;
  }
  function build() {
    if (document.getElementById('pv-compare') || document.getElementById('pv-included')) return;
    var anchor = document.querySelector('.product__info-container')
      || document.querySelector('product-form')
      || document.querySelector('main');
    if (!anchor) return;
    var host = anchor.tagName === 'MAIN' ? anchor : (anchor.closest('.shopify-section') || anchor);
    var box = buildBox();
    var cmp = buildCompare();
    if (host.tagName === 'MAIN') {
      host.appendChild(box); host.appendChild(cmp);
    } else {
      host.parentNode.insertBefore(box, host.nextSibling);
      box.parentNode.insertBefore(cmp, box.nextSibling);
    }
  }
  function init() { try { if (isProduct()) build(); } catch (e) {} }
  onReady(init);
})();
